export default {
  styleOverrides: {
    select: {
      textTransform: 'capitalize' as const,
    },
  },
};
